import axios from 'axios'
import { useEffect, useState } from 'react'
import authService from '../../../Components/Login/auth.service'

export default function Modal({ setOpenModal, auditorias }) {
    //console.log(auditorias)
    var user = authService.getCurrentUser()
    const [campos, setCampos] = useState('')
    const [pessoas, setPessoas] = useState([])

    const auditoriasSelecionadas = []
    //useEffect(() => {
    auditorias.forEach(auditoria => {
        auditoriasSelecionadas.push(auditoria.IdRetornoObservacao)
    })
    //})

    //console.log(auditoriasSelecionadas)

    useEffect(() => {
        axios
            .get(
                process.env.REACT_APP_API_URL +
                '/api/v1/pessoa/list/' +
                user[0].IdEmpresa +
                '/' +
                sessionStorage.IdUnidade
            )
            .then(response => {
                //console.log(pessoas)
                setPessoas(response.data)
            })
    }, [])

    function enviaRelatorio() {
        let mensagem = 'E-mail enviado! '
        //console.log(auditorias)
        auditorias.forEach(auditoria => {
            //emails alternativos
            if (campos !== '') {
                axios
                    .post(process.env.REACT_APP_API_URL + '/api/v1/send_email_checklist', {
                        IdRetornoObservacao: auditoria.IdRetornoObservacao,
                        to: campos.target.value
                    })
                    .then(response => {
                        //console.log(response.data.message)
                        if (response.status === 200) {
                            mensagem = mensagem + ` E-mail enviado para: ${campos.target.value},`
                            //alert("50")
                        } else {
                            mensagem = mensagem + ` Erro ao enviar para: ${campos.target.value},`
                            //alert("53")
                        }
                    })
                // .catch(error => {
                //   console.log(error.status)
                //   alert("campos: " + error.status)
                // })
            }
            //responsavel pela auditoria
            axios
                .get(
                    process.env.REACT_APP_API_URL + '/api/v1/retornoobservacao/' + auditoria.IdRetornoObservacao
                )
                .then(response => {
                    //console.log("65")
                    if (response.data.length > 0) {
                        axios
                            .post(process.env.REACT_APP_API_URL + '/api/v1/send_email_checklist', {
                                IdRetornoObservacao: auditoria.IdRetornoObservacao,
                                to: response.data[0].rtoResponsavelEmail
                            })
                            .then(response => {
                                //console.log(response.data.message)
                                if (response.status === 200) {
                                    mensagem = mensagem + ` E-mail enviado para: ${response.data[0].rtoResponsavelEmail},`
                                    //alert("76")
                                } else {
                                    mensagem = mensagem + ` Erro ao enviar para: ${response.data[0].rtoResponsavelEmail},`
                                    //alert("79")
                                }
                            })
                    }
                })
            // .catch(error => {
            //   console.log(error.status)
            //   alert("responsavel: " + error)
            // })

            //destinatarios selecionados na lista
            destinatarios.forEach(destinatario => {
                //console.log("89")
                axios
                    .post(process.env.REACT_APP_API_URL + '/api/v1/send_email_checklist', {
                        IdRetornoObservacao: auditoria.IdRetornoObservacao,
                        to: destinatario.pesEmail
                    })
                    .then(response => {
                        //alert("96")
                        //console.log(response.data.message)
                        if (response.status === 200) {
                            mensagem = mensagem + ` E-mail enviado para: ${destinatario.pesEmail},`
                            //alert("100")
                        } else {
                            mensagem = mensagem + ` Erro ao enviar para: ${destinatario.pesEmail},`
                            //alert("103")
                        }
                    })
                // .catch(error => {
                //   console.log(error.status)
                //   alert("destinatarios: " + error)
                // })
            })
        })
        //return
        alert(mensagem)
        //window.location.reload()
    }
    const [destinatarios, setDestinatarios] = useState([])
    function handleDestinatario(event) {
        const newList = destinatarios.filter(item => item.pesEmail !== event.target.name)
        //console.log(newList)
        if (event.target.checked == true) {
            const newList2 = newList.concat({
                pesEmail: event.target.name
            })
            setDestinatarios(newList2)
            //console.log(newList2)
        }
        else {
            setDestinatarios(newList)
            //console.log(newList)
        }
        //console.log(destinatarios)
        // if (event.target.checked == true) {
        //   if (destinatarios.length == 0) {
        //     const newList = destinatarios.filter(item => item.pesEmail !== event.target.name)
        //     setDestinatarios(newList)
        //   }
        //   else {
        //     const newList = destinatarios.concat({ pesEmail: event.target.name })
        //     setDestinatarios(newList)
        //   }

        // } else {
        //   const newList = destinatarios.filter(item => item.pesEmail !== event.target.name)
        //   const newList2 = newList.concat({
        //     pesEmail: event.target.name
        //   })
        //   setDestinatarios(newList2)

        // }


    }
    return (
        <>

            <div
                onClick={() => {
                    setOpenModal(false)
                }}
                className="overlay"
            ></div>
            <div className="modalPadrao-content">
                <div className="cxTituloPadrao">
                    <h1>
                        Selecione os destinatários
                        <hr className="hrTitleModal" />
                    </h1>
                </div>
                <form>
                    <label>E-mail alternativo:</label>
                    <input
                        type="email"
                        id="fname"
                        name="txtNotaValor"
                        onChange={setCampos}
                    ></input>
                    <div
                        className="tabelaPadrao"
                        style={{
                            marginTop: '10px',
                            left: '0',
                            width: '100%',
                            height: '250px'
                        }}
                    >
                        <table>
                            <thead>
                                <th>Nome</th>
                                <th>E-Mail</th>
                                <th>Função</th>
                                <th>Envio</th>
                            </thead>
                            <tbody>
                                {pessoas
                                    .filter(val => {
                                        if (val.pesStatus === 1) {
                                            return val
                                        }
                                    })
                                    .map(pessoa => (
                                        <tr>
                                            <td>{pessoa.pesNome}</td>
                                            <td>{pessoa.pesEmail}</td>
                                            <td>{pessoa.fncDescricao}</td>
                                            <td>
                                                <label className="container">
                                                    <input
                                                        name={pessoa.pesEmail}
                                                        type="checkbox"
                                                        onChange={handleDestinatario} />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="caixaSalvarPadrao">
                        <button onClick={enviaRelatorio}>Enviar</button>
                    </div>
                </form>
            </div>
        </>
    )
}
